import { IIconProps } from "../types"

export default function IconUL5(props: IIconProps) {
  const width = props.size || props.width || 83 /5*3
  const height = props.size || props.height || 103 /5*3
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 83 103"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.1737 1.02161C46.3853 0.131892 41.6468 0.211866 37.5081 1.74138C33.3595 3.26089 29.8006 6.21994 26.2517 10.6685C22.6929 15.1071 19.144 21.0252 15.3752 27.5431C11.6064 34.061 7.6377 41.1687 5.09852 46.8769C2.56933 52.5951 1.46968 56.9037 0.879871 61.1823C0.29006 65.451 0.200089 69.6896 1.28974 73.9182C2.38939 78.1469 4.67865 82.3755 7.25783 85.9344C9.837 89.4832 12.7161 92.3623 16.6848 95.1914C20.6635 98.0305 25.7419 100.82 31.4501 101.839C37.1682 102.859 43.5162 102.089 48.9645 101.16C54.4327 100.23 59.0012 99.1301 62.6301 96.9708C66.2789 94.8115 68.978 91.6026 71.9871 87.7538C74.9861 83.895 78.2851 79.4165 79.9945 74.2981C81.704 69.1798 81.8239 63.4216 81.484 56.8237C81.1441 50.2258 80.3544 42.7782 79.2347 36.0504C78.1251 29.3225 76.6856 23.3145 74.3563 18.366C72.0271 13.4176 68.8081 9.51888 64.7894 6.6498C60.7707 3.77073 55.9522 1.91132 51.1737 1.02161Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.899712"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
